import React from "react";
import { TextField } from "react-admin";
import { prop } from "ramda";

export const TextBooleanField = ({ record , source, ...rest }) => {
  const newSource = `${source}Text`;

  const booleanValue = prop(source, record);
  const newValue = booleanValue ? "Yes" : "No";

  const newRecord = Object.assign(record, {[newSource]: newValue })

  return <TextField source={newSource} record={newRecord} {...rest} />;
}

TextBooleanField.defaultProps = {
  addLabel: true,
};



// WEBPACK FOOTER //
// ./src/components/TextBooleanField.js